import { Component, input } from '@angular/core';
import type { Swap } from '../../../interfaces/swap/swap';
import { SwapModalNoteItemComponent } from './swap-modal-note-item/swap-modal-note-item.component';

@Component({
  selector: 'app-swap-modal-note',
  imports: [SwapModalNoteItemComponent],
  templateUrl: './swap-modal-note.component.html',
  styleUrl: './swap-modal-note.component.scss',
})
export class SwapModalNoteComponent {
  public readonly swap = input.required<Swap>();
  public readonly isDouble = input.required<boolean>();
}
